import CrudManager from "@/components/admin/CrudManager";
import { useSeo } from "@/hooks/useSeo";

const AdminGaleri = () => {
  useSeo("Kelola Galeri");
  return (
    <CrudManager
      title="Galeri"
      description="Tambah, edit (foto, keterangan, kategori), dan hapus foto dokumentasi."
      endpoint="/gallery"
      prefix="admin-gallery"
      defaults={{ category: "Kegiatan" }}
      columns={[
        { name: "image_url", image: true },
        { name: "title" },
        { name: "category" },
      ]}
      fields={[
        { name: "image_url", label: "Foto", type: "image", required: true },
        { name: "title", label: "Judul / Keterangan", type: "text", placeholder: "Keterangan foto" },
        { name: "category", label: "Kategori", type: "select", options: ["Kegiatan", "Akademik", "Keagamaan", "Seni", "Olahraga"] },
      ]}
    />
  );
};

export default AdminGaleri;
